import { render, staticRenderFns } from "./ProductIssueType.vue?vue&type=template&id=5c7bedb4&"
import script from "./ProductIssueType.vue?vue&type=script&lang=js&"
export * from "./ProductIssueType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports